import { render, staticRenderFns } from "./FalhaVenda.vue?vue&type=template&id=5f543345&"
import script from "./FalhaVenda.vue?vue&type=script&lang=js&"
export * from "./FalhaVenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports